// extracted by mini-css-extract-plugin
export default {"wrapper":"Editable_wrapper__ojfO4","wrapper__date":"Editable_wrapper__date__clfkW"};